import { DesignSystem } from '@/src/design-system'
import { View, XStack, YStack } from 'tamagui'

export function MortgageRewardsSkeleton() {
  return (
    <YStack gap="$4">
      <DesignSystem.Skeleton.Skeleton style={{ width: '100%', height: 121, overflow: 'hidden' }} />
      <XStack gap="$4">
        <View grow={1} shrink={1}>
          <DesignSystem.Skeleton.Skeleton
            style={{ width: '100%', height: 116, overflow: 'hidden' }}
          />
        </View>
        <View grow={1} shrink={1}>
          <DesignSystem.Skeleton.Skeleton
            style={{ width: '100%', height: 116, overflow: 'hidden' }}
          />
        </View>
      </XStack>
    </YStack>
  )
}
